export const MAX_CUSTOM_PERIOD_LENGTH = 12; // month
